export default class QueryVariablesFormController {
	/* @ngInject */
	constructor() {
		/** @type {?import('../query-editor/query-editor.controller').default} */
		this.editor = null;

		/** @type {?import('~/components/query/query-tab').default} */
		this.tab = null;
	}

	/**
	 * @param {import('~/scripts/services/model/query-variable').default} variable
	 */
	reset(variable) {
		if (this.tab) {
			this.tab.variable[variable.id] = variable.value;
		}
	}
}
